import { createApp } from 'vue'
import FormInputTextarea from './FormInputTextarea'

const el = '.kb-component--form-input-textarea'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((FormInputTextareaDOM) => {
            const props = {
                type: FormInputTextareaDOM.dataset.type,
                tooltipText: FormInputTextareaDOM.dataset.tooltiptext,
                errorMessageLabel:
                    FormInputTextareaDOM.dataset.errormessagelabel,
                helpMessageLabel:
                    FormInputTextareaDOM.dataset.helpmessagelabel,
                placeholder: FormInputTextareaDOM.dataset.placeholder,
                label: FormInputTextareaDOM.dataset.label,
                isRequired: !!(
                    FormInputTextareaDOM.dataset.isrequired === 'true'
                ),
                fieldName: FormInputTextareaDOM.dataset.fieldname
            }

            const component = createApp(FormInputTextarea, props).use(Store)
            component.mount(FormInputTextareaDOM)
        })
    }
}
